<template>
  <div>
    <v-card class="pa-0 pb-10" tile>
      <v-card-title>
        <h4 class="primary--text">
          {{ $t('sidebar.contractors.spedilink') }}
        </h4>
        <v-spacer />
        <v-btn
          color="primary"
          depressed
          @click="addPersonDialog = true"
        >
          {{ $t('spedilink.persons.add') }}
        </v-btn>
      </v-card-title>

      <v-card class="py-5">
        <PublicSpedilinkPersonsTable ref="personsTable" />
      </v-card>
    </v-card>

    <AddPublicSpediLinkPersonDialog
      v-model="addPersonDialog"
      @person-added="onPersonAdded"
      @close="addPersonDialog = false"
    />
  </div>
</template>

<script>
import PublicSpedilinkPersonsTable from '@/views/Companies/CustomerService/PublicSpedilink/PublicSpedilinkPersonsTable'
import AddPublicSpediLinkPersonDialog from '@/views/Companies/CustomerService/PublicSpedilink/AddPublicSpediLinkPersonDialog'

export default {
  name: 'PublicSpedilinkPersons',
  components: {
    PublicSpedilinkPersonsTable,
    AddPublicSpediLinkPersonDialog
  },
  data () {
    return {
      addPersonDialog: false
    }
  },
  methods: {
    async onPersonAdded () {
      this.addPersonDialog = false
      if (this.$refs.personsTable) {
        await this.$refs.personsTable.loadPersons()
      }
    }
  }
}
</script>
